module.exports = __webpack_public_path__ + "static/img/vue.74ef731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/discover/vue.png
// module id = rFlL
// module chunks = 1